import { ActivityType } from '@wdx/shared/swagger-gen';
import {
    EMAIL_FORM_ID,
    LETTER_FORM_ID,
    MEETING_FORM_ID,
    PHONECALL_FORM_ID,
    SMS_FORM_ID,
} from './form-ids.static';

export interface ActivityQuickCreateForm {
    activityType: ActivityType;
    formId: string;
    labelKey: string;
}

export const ACTIVITY_QUICK_CREATE_FORMS: ActivityQuickCreateForm[] = [
    {
        activityType: ActivityType.PhoneCall,
        formId: PHONECALL_FORM_ID,
        labelKey: 'ACTIVITY_TYPE_PHONECALL',
    },
    {
        activityType: ActivityType.Appointment,
        formId: MEETING_FORM_ID,
        labelKey: 'ACTIVITY_TYPE_MEETING',
    },
    {
        activityType: ActivityType.Sms,
        formId: SMS_FORM_ID,
        labelKey: 'ACTIVITY_TYPE_MESSAGE',
    },
    {
        activityType: ActivityType.Email,
        formId: EMAIL_FORM_ID,
        labelKey: 'ACTIVITY_TYPE_EMAIL',
    },
    {
        activityType: ActivityType.Letter,
        formId: LETTER_FORM_ID,
        labelKey: 'ACTIVITY_TYPE_LETTER',
    },
];
